export default "__VITE_ASSET__66ec1a92__"